
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/marketplace/[...params]",
      function () {
        return require("private-next-pages/marketplace/[...params].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/marketplace/[...params]"])
      });
    }
  